import { gsap } from 'gsap';
import Flickity from 'flickity';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

import 'flickity-imagesloaded';
import 'flickity-bg-lazyload';
import 'flickity-fade';
import { throttle } from 'lodash';

const MOS = {};
window.MOS = MOS;

(() => {
  const SCREENMDMAX = 1199;
  const HEADER_HEIGHT = 100;
  let winSize = 0;
  const calcWinSize = () => {
    winSize = { width: window.innerWidth, height: window.innerHeight };
  };

  const scrollTo = (elt, duration, target, offsetY) => {
    console.log('scrollto', elt, duration, target);
    gsap.to(
      window,
      {
        duration: duration || 1,
        scrollTo: (elt.getBoundingClientRect().top + window.scrollY) - (offsetY || 0),
        onComplete: () => {
          if (target !== undefined) {
            // window.location.hash = target;
          }
        },
      },
    );
  };

  const scrollToId = (href) => {
    if (href !== undefined) {
      const target = href.split('#')[1];
      if (document.getElementById(target) !== null) {
        scrollTo(document.getElementById(target), 1, target);
      }
    }
  };

  class AccordionMenuItem {
    constructor(elt, opts) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('.c-accordion-menu__btn');
      this.DOM.link = this.DOM.elt.querySelector('.c-accordion-menu__link');
      this.DOM.content = this.DOM.elt.querySelector('.c-accordion-menu__content');
      this.isOpen = this.DOM.elt.classList.contains('is-active');
      this.opts = opts;
    }
    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      const self = this;
      if (action === 'SHOW') {
        gsap.to(self.DOM.content, { duration: 0.6, height: 'auto' });
        if (self.DOM.btn && self.opts.scrollTo === true) {
          scrollTo(self.DOM.btn, 1, null, HEADER_HEIGHT);
        }
        self.DOM.elt.classList.add('is-active');
      } else {
        gsap.to(self.DOM.content, {
          duration: 0.4,
          height: 0,
          onComplete: () => {
            self.DOM.elt.classList.remove('is-active');
          },
        });
      }
    }
  }
  class AccordionMenu {
    constructor(elt) {
      const self = this;
      self.DOM = { elt };
      self.settings = self.DOM.elt.hasAttribute('data-accordion') ? JSON.parse(self.DOM.elt.getAttribute('data-accordion')) : {};
      self.menuItems = [];
      Array.from(self.DOM.elt.querySelectorAll('.c-accordion-menu__item')).forEach(item => self.menuItems.push(new AccordionMenuItem(item, self.settings)));
      self.init();
      console.log('AccordioMenu::init', self.menuItems.length, self.settings);
    }

    init() {
      this.current = 0;
      this.initEvents();
      if (typeof this.settings !== 'undefined' && 'autoOpen' in this.settings) {
        this.showContent(this.settings.autoOpen);
      }
    }

    initEvents() {
      for (const [pos, item] of this.menuItems.entries()) {
        if (item.DOM.btn) {
          item.DOM.btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
        if (item.DOM.link) {
          item.DOM.link.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
      }
    }

    showContent(pos) {
      console.log('POS', pos);
      if (typeof this.settings !== 'undefined' && 'autoClose' in this.settings) {
        if (this.current !== pos && this.menuItems[this.current].isOpen) {
          this.menuItems[this.current].hide();
        }
      }
      this.menuItems[pos].toggleCurrent();
      this.current = pos;
    }
  }
  class Carousels {
    constructor(element) {
      if (element.querySelector('.js-carousel')) {
        console.log('Carousels::init', element.querySelectorAll('.js-carousel').length);
        const self = this;
        self.DOM = {
          elts: [],
          eltWrapper: element,
        };
        element.querySelectorAll('.js-carousel').forEach((elt) => {
          self.DOM.elts.push(elt);
        });
        self.flcks = [];
        self.init();
      }
    }
    init() {
      let idx = 0;
      const self = this;
      self.DOM.elts.forEach((instance) => {
        console.log('Carousels::init', idx);
        const flck = new Flickity(instance);
        if (self.DOM.eltWrapper.querySelector('.btn--next') && self.DOM.eltWrapper.querySelector('.btn--prev')) {
          self.DOM.eltWrapper.querySelector('.btn--next').addEventListener('click', (e) => {
            e.preventDefault();
            flck.next(true, false);
          });
          self.DOM.eltWrapper.querySelector('.btn--prev').addEventListener('click', (e) => {
            e.preventDefault();
            flck.previous(true, false);
          });
        }
        self.flcks.push(flck);
        idx += 1;
      });
    }
  }
  class DDMenuItem {
    constructor(elt) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('button');
      this.DOM.content = this.DOM.elt.querySelector('.menu-item__level');
      this.isOpen = this.DOM.elt.classList.contains('is-active');
      this.init();
    }

    init() {
      const self = this;
      self.DOM.btn.addEventListener('click', self.toggleCurrent.bind(self));
    }

    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      if (action === 'SHOW') {
        gsap.to(this.DOM.content, { height: 'auto', duration: 0.3 });
        this.DOM.elt.classList.add('is-active');
      } else {
        gsap.to(this.DOM.content, { height: 0, duration: 0.3 });
        this.DOM.elt.classList.remove('is-active');
      }
    }
  }
  class SideNav {
    constructor(elt, eltWrapper) {
      if (document.querySelector(elt) && document.querySelector(eltWrapper)) {
        const self = this;
        self.DOM = { elt: document.querySelector(elt) };
        self.DOM.eltWrapper = document.querySelector(eltWrapper);
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.DOM.openBtn = self.DOM.eltWrapper.querySelector('.btn-burger');
        self.isOpen = false;
        self.initEvents();
      }
    }
    initEvents() {
      console.log('SideNav::initEvents');
      const self = this;
      self.DOM.openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.isOpen) {
          this.toggle('close');
        } else {
          this.toggle('open');
        }
      });
      self.menuItems = [];
      Array.from(self.DOM.elt.querySelectorAll('.menu__item--ddm')).forEach(item => this.menuItems.push(new DDMenuItem(item)));
    }

    toggle(action, _self) {
      const self = _self || this;
      self.isOpen = action === 'open';

      if (self.isOpen) {
        self.DOM.elt.classList.add('is-open');
        self.DOM.openBtn.classList.add('is-active');
      } else {
        self.DOM.elt.classList.remove('is-open');
        self.DOM.openBtn.classList.remove('is-active');
      }
    }
  }
  class MainNav {
    constructor(elt, eltWrapper) {
      const self = this;
      if (document.querySelector(elt) && document.querySelector(eltWrapper)) {
        self.DOM = { elt: document.querySelector(elt) };
        self.DOM.eltWrapper = document.querySelector(eltWrapper);
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.DOM.toggleBtn = document.querySelector('.btn-burger');
        self.DOM.closeBtn = self.DOM.eltWrapper.querySelector('.btn-close');
        self.isOpen = false;
        self.initEvents();
      }
    }

    initEvents() {
      console.log('MainNav::initEvents');
      const self = this;
      self.DOM.toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (self.isOpen) {
          self.toggle('close');
          document.querySelector('body').classList.remove('is-open');
        } else {
          self.toggle('open');
          document.querySelector('body').classList.add('is-open');
        }
      });

      if (self.DOM.closeBtn) {
        self.DOM.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggle('close');
        });
      }

      if (MOS.Util.hasTouchScreen() || winSize.width < 1200) {
        self.menuItems = [];
        Array.from(self.DOM.elt.querySelectorAll('.menu__item--ddm')).forEach(item => this.menuItems.push(new DDMenuItem(item)));
      }

      if (self.settings.sticky !== undefined && self.settings.sticky
        && winSize.width > SCREENMDMAX) {
        window.addEventListener('scroll', throttle(self.onScroll.bind(self), 500, { leading: true, trailing: true }));
      }
    }

    open() {
      this.DOM.elt.classList.add('is-open');
      this.DOM.toggleBtn.classList.add('is-active');
      this.isOpen = true;
    }

    close() {
      this.DOM.elt.classList.remove('is-open');
      this.DOM.toggleBtn.classList.remove('is-active');
      this.isOpen = false;
    }

    toggle(action, _self) {
      const self = _self || this;
      self.isOpen = action === 'open';

      if (self.isOpen) {
        self.open();
      } else {
        self.close();
      }
    }

    onScroll(e) {
      const windowScrollY = window.scrollY;
      if (windowScrollY > 50) {
        this.DOM.elt.classList.add('is-sticky');
        this.DOM.isSticky = true;
      } else {
        this.DOM.elt.classList.remove('is-sticky');
        this.DOM.isSticky = false;
      }
      // console.log('StickyNav::scrolling', windowScrollY);
    }
  }
  class Header {
    constructor(elt) {
      const self = this;
      if (document.querySelector(elt)) {
        self.DOM = { elt: document.querySelector(elt) };
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.initEvents();
      }
    }

    initEvents() {
      console.log('Header::initEvents');
      const self = this;
      window.addEventListener('scroll', throttle(self.onScroll.bind(self), 500, { leading: true, trailing: true }));
    }

    onScroll() {
      const windowScrollY = window.scrollY;
      if (windowScrollY > 50) {
        this.DOM.elt.classList.add('is-sticky');
        this.DOM.isSticky = true;
      } else {
        this.DOM.elt.classList.remove('is-sticky');
        this.DOM.isSticky = false;
      }
      // console.log('StickyNav::scrolling', windowScrollY);
    }
  }
  class Videos {
    constructor(elt) {
      this.DOM = { elt };
      this.initEvents();
    }

    initEvents() {
      const self = this;
      const videoEl = self.DOM.elt.querySelector('video');
      const btn = self.DOM.elt.querySelector('.video-play-overlay');
      btn.addEventListener('click', () => {
        videoEl.play().catch(err => console.warn(err));
      });

      // Hide overlay once video actually plays
      videoEl.addEventListener('play', () => {
        btn.classList.add('hidden');
      });

      // When paused, show the overlay again
      videoEl.addEventListener('pause', () => {
        btn.classList.remove('hidden');
      });

      // When video ends, reset to replay
      videoEl.addEventListener('ended', () => {
        btn.classList.remove('hidden');
      });

      function startOnClickOnce() {
        videoEl.play().catch(err => console.warn(err));
        videoEl.removeEventListener('click', startOnClickOnce);
      }

      videoEl.addEventListener('click', startOnClickOnce);
    }
  }

  function init() {
    MOS.sideNav = new SideNav('.c-main-nav[data-menu-style="sidenav"]', '.c-main-nav__wrapper');
    MOS.mainNav = new MainNav('.c-main-nav', '.c-main-nav__wrapper');
    MOS.header = new Header('.main-header[data-menu-type="sticky"]');
    MOS.videos = [];
    document.querySelectorAll('.js-video-wrapper').forEach((element) => {
      MOS.videos.push(new Videos(element));
    });

    if (document.querySelectorAll('.c-accordion-menu')) {
      MOS.accordionMenu = [];
      document.querySelectorAll('.c-accordion-menu').forEach((element) => {
        MOS.accordionMenu.push(new AccordionMenu(element));
      });
    }

    if (document.querySelector('.js-carousel-wrapper')) {
      MOS.carousels = [];
      document.querySelectorAll('.js-carousel-wrapper').forEach((element) => {
        MOS.carousels.push(new Carousels(element));
      });
    }
    if (window.location.hash) {
      gsap.delayedCall(1, scrollToId, [window.location.hash]);
    }

    // hijack link with anchors & scroll to
    document.querySelectorAll('a[href^="#"]').forEach((elt) => {
      elt.addEventListener('click', (e) => {
        e.preventDefault();
        const href = e.currentTarget.getAttribute('href');
        if (href !== undefined) {
          const target = href.split('#')[1];
          if (document.getElementById(target) !== null) {
            scrollTo(document.getElementById(target));
          }
        }
      });
    });

    // Card flip (BHAFC players cards)
    document.querySelectorAll('.c-card--flip').forEach((card) => {
      const front = card.querySelector('.c-card__front');
      const back = card.querySelector('.c-card__back');
      if (!front || !back) return;

      const flipOn = () => card.classList.add('is-active');
      const flipOff = () => card.classList.remove('is-active');
      const flipToggle = () => card.classList.toggle('is-active');

      // Primary trigger: button(s) in the front side.
      front.querySelectorAll('.btn, button').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          // If the button is meant to be a link later, this prevents accidental navigation.
          e.preventDefault();
          e.stopPropagation();
          flipToggle();
        });
      });

      // If back is visible, clicking empty back area flips back (buttons remain clickable).
      back.addEventListener('click', (e) => {
        if (!card.classList.contains('is-active')) return;
        if (e.target.closest('button, a, .btn')) return;
        flipOff();
      });

      // Escape closes the back when focus is inside the card.
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && card.classList.contains('is-active')) {
          e.preventDefault();
          flipOff();
        }
      });
    });
  }

  MOS.Util = {
    hasTouchScreen: () => {
      let hasTouch = false;
      if ('ontouchstart' in window) {
        hasTouch = true;
      } else if ('maxTouchPoints' in navigator) {
        hasTouch = navigator.maxTouchPoints >= 1 && navigator.maxTouchPoints <= 10;
      } else if ('msMaxTouchPoints' in navigator) {
        hasTouch = navigator.msMaxTouchPoints > 0;
      } else {
        const mQ = window.matchMedia && matchMedia('(pointer:coarse)');
        if (mQ && mQ.media === '(pointer:coarse)') {
          hasTouch = !!mQ.matches;
        } else if ('orientation' in window) {
          hasTouch = true; // deprecated, but good fallback
        } else {
          // Only as a last resort, fall back to user agent sniffing
          const UA = navigator.userAgent;
          hasTouch = (
            /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
            /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
          );
        }
      }
      return hasTouch;
    },
  };
  document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollToPlugin);
    calcWinSize();
    init();
  });
})();
